import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useGeneralStore = defineStore('generalStore', {
  state: () => {
    const passwordReset = ref(false); // Will be used in otp screen for redirect
    const notifyUrl = ref('');
    const iFrame = ref(false);
    const isMenuOpen = ref(false);

    return { passwordReset, notifyUrl, iFrame, isMenuOpen };
  },
  actions: {
    reset() {
      this.$reset();
    },
  },
  persist: true,
});
